import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ChatPanel } from '../components/ChatPanel.jsx';
import { useChatSocket } from '../hooks/useChatSocket.js';

const API_BASE = '/api';

async function guestJson(path, options = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    headers: { Accept: 'application/json', 'Content-Type': 'application/json', ...(options.headers || {}) },
    ...options,
    body: options.body ? JSON.stringify(options.body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || res.statusText);
  return data;
}

export function GuestChatPage() {
  const { organizationId } = useParams();
  const [started, setStarted] = useState(false);
  const [conversationId, setConversationId] = useState(null);
  const [guestToken, setGuestToken] = useState(null);
  const [socketToken, setSocketToken] = useState(null);
  const [form, setForm] = useState({ name: '', email: '', subject: '' });
  const [error, setError] = useState('');

  const start = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const data = await guestJson(`/public/chat/${organizationId}/guest`, {
        method: 'POST',
        body: form,
      });
      setConversationId(data.conversation.id);
      setGuestToken(data.guest_token);
      setSocketToken(data.socket_token);
      setStarted(true);
    } catch (err) {
      setError(err.message);
    }
  };

  const fetchToken = useCallback(async () => ({ token: socketToken }), [socketToken]);

  const { connected, connecting, messages, sendMessage, error: socketErr, appendMessage } = useChatSocket({
    fetchSocketToken: fetchToken,
    conversationId: started ? conversationId : null,
    guestToken,
  });

  const attachmentAuth = { guestToken, organizationId: parseInt(organizationId, 10) };

  if (!started) {
    return (
      <div className="auth-wrap">
        <form onSubmit={start} className="auth-card stack">
          <h2>Chat with us</h2>
          {error ? <p className="err">{error}</p> : null}
          <label className="field">
            <span>Name</span>
            <input
              className="form-control"
              required
              value={form.name}
              onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
            />
          </label>
          <label className="field">
            <span>Email</span>
            <input
              type="email"
              className="form-control"
              required
              value={form.email}
              onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
            />
          </label>
          <label className="field">
            <span>Subject (optional)</span>
            <input
              className="form-control"
              value={form.subject}
              onChange={(e) => setForm((f) => ({ ...f, subject: e.target.value }))}
            />
          </label>
          <button type="submit" className="btn-primary">
            Start chat
          </button>
        </form>
      </div>
    );
  }

  return (
    <div className="auth-wrap">
      <div style={{ maxWidth: 640, width: '100%' }}>
        <h2>Live chat</h2>
        {socketErr ? <p className="err">{socketErr}</p> : null}
        <ChatPanel
          messages={messages}
          connected={connected}
          connecting={connecting}
          onSend={sendMessage}
          onAttachmentUploaded={appendMessage}
          conversationId={conversationId}
          attachmentAuth={attachmentAuth}
        />
      </div>
    </div>
  );
}
